import api from './api'

export const statistics = {
  getBasicStatisticalData: () => {
    return api.get(`/CloudParkAPI/Data/GetBasicStatisticalData`)
  },
  getMonthlyCardData: () => {
    return api.get(`/CloudParkAPI/Data/GetMonthlyCardData`)
  },
  getPayTypeAmountData: () => {
    return api.get(`/CloudParkAPI/Data/GetPayTypeAmountData`)
  },
  getEquList: () => {
    return api.get(`/CloudParkAPI/Data/GetEquList`)
  },
  getCouponBatchDetailCount: () => {
    return api.get(`/CloudParkAPI/Data/GetCouponBatchDetailCount`)
  },
  getVehicleInAndOutData: () => {
    return api.get(`/CloudParkAPI/Data/GetVehicleInAndOutData`)
  },
  getTodayStat: () => {
    return api.get(`/CloudParkAPI/NewStatistic/GetTodayStatAsync`)
  },
  getTodayParkStat: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetTodayParkStatAsync`, params)
  },
  getHisStat: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetHisStatAsync`, params)
  },
  getHisParkStat: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetHisParkStatAsync`, params)
  },
  getParkList: (params) => {
    return api.post(`/CloudParkAPI/PCUser/ParkListAsync`, params)
  },
  getParkTodayStat: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetParkTodayStatAsync`, params)
  },
  getInParkOrOutParkCnt: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetInParkOrOutParkCntAsync`, params)
  },
  getDayParkRate: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetDayParkRateAsync`, params)
  },
  getParkPayStatis: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetParkPayStatisAsync`, params)
  },
  getParkPayList: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetParkPayListAsync`, params)
  },
  getInOrOutCnt: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetInOrOutCntAsync`, params)
  },
  getInCardType: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetInCardTypeAsync`, params)
  },
  getOutCardType: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetOutCardTypeAsync`, params)
  },
  getVehicleByID: (params) => {
    return api.post(`/CloudParkAPI/NewStatistic/GetVehicleInAndOutDataAsync`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/statistics.js